import { z } from 'zod';
import { enumChecker } from '@soundxyz/utils/const';

export const SEARCH_TAB_CHOICES = {
  ALL: 'all',
  SOUNDS: 'sounds',
  ARTISTS: 'artists',
  PLAYLISTS: 'playlists',
  COLLECTORS: 'collectors',
} as const;

export const EXPLORE_TYPES = {
  SOUNDS: 'sounds',
  ARTISTS: 'artists',
  PLAYLISTS: 'playlists',
  COLLECTORS: 'collectors',
  UPCOMING_DROPS: 'upcomingDrops',
} as const;

export type TabChoice = (typeof SEARCH_TAB_CHOICES)[keyof typeof SEARCH_TAB_CHOICES];

export type ExploreTypeChoice = (typeof EXPLORE_TYPES)[keyof typeof EXPLORE_TYPES];

const SearchTabSchema = z.object({
  activeTab: z.nativeEnum(SEARCH_TAB_CHOICES),
  exploreType: z.nativeEnum(EXPLORE_TYPES).nullable(),
});

export type SearchTabs = z.infer<typeof SearchTabSchema>;

export type SearchPageStoreState = z.infer<typeof SearchTabSchema>;

export const isSearchTab = enumChecker(SEARCH_TAB_CHOICES);
